const cardData = [
  {
    icon: "/assets/UIUX/img1.svg",
    heading: "Machine Learning Analytics",
    paragraph:
      "Transform business data into predictive insights that help identify trends, optimize operations, and support smarter decision-making.",
  },
  {
    icon: "/assets/UIUX/img2.svg",
    heading: "ML Infrastructure & Pipelines",
    paragraph:
      "Build scalable machine learning pipelines and data architectures designed for model training, processing, automation, and intelligent analytics workflows.",
  },
  {
    icon: "/assets/UIUX/img3.svg",
    heading: "AI & ML Consulting",
    paragraph:
      "We help businesses identify machine learning opportunities, align AI strategies with operational goals, and build scalable intelligent systems.",
  },
];

const points = [
  {
    content1: "Predict Smarter – ",
    content2:
      "Identify trends, patterns, and opportunities through intelligent data analysis",
  },
  {
    content1: "Automate Decisions – ",
    content2:
      "Reduce manual processes using AI-assisted predictions and intelligent workflows",
  },
  {
    content1: "Scale Intelligently – ",
    content2:
      "Build machine learning systems designed for long-term operational growth",
  },
  {
    content1: "Improve Accuracy - ",
    content2:
      "Enhance forecasting, monitoring, and business visibility through predictive analytics",
  },
  {
    content1: "Operate Efficiently - ",
    content2:
      "Streamline data-driven processes with scalable ML infrastructure and automation",
  },
];

export { cardData, points };
